import React from 'react';
import ComponentErp from './ComponentErp.js';
import store from '../store';

import FormEdit from '../components/FormEdit.js';
import { getSisTipoVencimento } from '../services/Auth.js';
import { GetContasReceberAPI } from '../models/ModelContasReceber.js';
import ContasReceberUpdate from './ContasReceberUpdate.js';


class ContasReceber extends ComponentErp {
  constructor(props) {
    super(props);
    this.state = store.getState().contasReceber.grids;
  }

  componentDidMount() {
    this.callApi()
  }

  componentDidUpdate(prevProps, prevState) {

    if (this.state.refresh === 'gravando') {
      this.setState({ refresh: 'buscando' });
      this.callApi()
    }
  }

  handleSubmit = (event) => {
    event.preventDefault()
    var response = {
      refresh: 'gravando',
      fNome: this.state.fNome,
      fSituacao: this.state.fSituacao,
      type: 'CONTASRECEBER.TOOGLE_FBUSCA'
    }
    this.updateReduxAndState(response);

  }

  refreshBusca = () => {
    var response = {
      refresh: 'gravando',
      fNome: this.state.fNome,
      fSituacao: this.state.fSituacao,
      type: 'CONTASRECEBER.TOOGLE_FBUSCA'
    }
    this.updateReduxAndState(response);

  }

  clickChildCadastro = (event, id) => {
    event.preventDefault()

    var response = {
      id: id,
      type: 'CONTASRECEBER.TOOGLE_CADASTRO',
      refresh: 'buscacontasreceber'
    }

    this.updateReduxAndState(response);

    this.actionClick('.cadastro');
    this.clearModal();

  }

  async callApi() {
    var grids = store.getState().contasReceber.grids;
    var response = await GetContasReceberAPI(grids.limit, grids.offset, grids.fNome, grids.fSituacao);
    response.refresh = 'concluido';
    response.onClickModal = this.clickChildCadastro;
    response.callBackPaginacao = this.callBackPaginacao;
    response.type = 'CONTASRECEBER.TOOGLE_LISTA';

    this.updateRedux(response);
    grids = store.getState().contasReceber.grids;
    this.setState(grids);
  }



  render() {

    return (

      <div className="container">
        <div className="row">
          <h2 className="section-title">Contas à receber</h2>
          <div className="card">
            {this.navMenu(store.getState().contasReceber.grids.nav)}

            <div id="lista" className="dataTables_wrapper no-footer row">
              <form name="form" onSubmit={this.handleSubmit} action="" method="get" encType="multipart/form-data">

                {<FormEdit id='fNome'
                  label='Busque por nome'
                  defaultValue={this.state.fNome}
                  onChange={this.handleInputChange}
                  styleDiv='4' />}

                {<FormEdit id='fSituacao'
                  label='Situação'
                  styleDiv='4'
                  typeField='select'
                  value={this.state.fSituacao}
                  required='on'
                  onChange={this.handleInputChange}
                  optionsField={getSisTipoVencimento('contasreceber')}
                />}

                {<FormEdit id='submit'
                  label='Pesquisar'
                  styleDiv='submit'
                  styleField='submit'
                  typeField='submit'
                  icon='pesquisa'
                />}

              </form>

              {this.Grid(store.getState().contasReceber.grids)}

            </div>
            <div id="cadastro" className="dataTables_wrapper no-footer row">
              {<ContasReceberUpdate refreshBusca={this.refreshBusca} />}
            </div>
          </div>
        </div>
      </div>

    );

  }
}
export default (ContasReceber);
